module.exports = __webpack_public_path__ + "static/media/Home Page_website-09.aa37ede4.png";